import { useEffect, useState } from "react";
import { BusyLabel } from "@/components/loading";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CreditCard } from "lucide-react";

export default function MockPay() {
  const [params] = useSearchParams();
  const tx = params.get("tx");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const approve = async () => {
    setLoading(true);
    try {
      // Try as bundle first (cart), fall back to single order
      try {
        await api.post(`/mock/bundles/${tx}/approve`);
      } catch {
        await api.post(`/mock/payments/${tx}/approve`);
      }
      toast.success("Pago aprobado (mock)");
      nav(`/payment-result?tx=${tx}&status=approved`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error");
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="bg-[#111] border border-[#262626] rounded-md p-8 text-center">
        <CreditCard size={40} className="text-[#EF4444] mx-auto mb-4" />
        <h1 className="font-display text-2xl mb-2">PAGO SIMULADO</h1>
        <p className="text-neutral-400 text-sm mb-6">Modo <b className="text-[#EF4444]">MOCK</b> activo. En producción, aquí Payphone te mostraría su formulario de pago.</p>
        <div className="text-neutral-500 text-xs mb-6">Orden/Bundle: <code className="text-white">{tx}</code></div>
        <Button data-testid="mock-approve" onClick={approve} disabled={loading} className="w-full bg-[#EF4444] hover:bg-[#DC2626] h-12">
          <BusyLabel busy={loading} text="Procesando pago…">Aprobar pago</BusyLabel>
        </Button>
      </div>
    </div>
  );
}
